export default class Historico {
  constructor() {
    this.nome = ""
    this.prazoLegal = ""
    this.prazoEntrega = ""
    this.aPartirDe = ""
    this.statusId = ""
    this.geraMulta = ""
    this.padrao = ""
    this.ativo = ""
    this.empresasIds = []
    this.responsavelId = ""
    this.departamentoId = ""
    this.recorrenciaId = 1
    this.competenciaId = ""
    this.tipoPrazoEntregaFinalId = ""
    this.tipoPrazoEntregaLegalId = ""
    this.tarefaCliente = false
    this.textoPeriodoReferencia = ""

  }
}
